<template>
  <div class="text-center" :class="isTransport ? 'content-2' : isFreight ? 'content-3' : 'content-2-general' ">
    <h1 :class="isTransport ? 'title-main': 'title-main-general'">{{title}}</h1>
    <hr style="color: white; width: 100px;">
    <h3 id="sub-title">Então compartilhe com seus amigos nas redes sociais ou indique</h3>
    <div class="row">
      <div class="col-4 offset-4">
        <social-sharing url="http://www.multicargo.io/" inline-template>
        <div class="social">
          <network class="network" network="facebook" style="margin-right: 2rem;">
            <i class="fab fa-facebook-f" style="font-size: 24px !important"></i>
          </network>
          <network class="network" network="googleplus" style="margin-right: 2rem;">
            <i class="fab fa-google-plus-g icon" style="font-size: 24px !important"></i>
          </network>
          <network class="network" network="linkedin" style="margin-right: 2rem;">
            <i class="fab fa-linkedin-in" style="font-size: 24px !important"></i>
          </network>
          <a style="color: white;"  target="_blank" href="https://api.whatsapp.com/send?text=https%3A%2F%2Fwww.multicargo.io">
            <network network="whatsapp">
            <i class="fab fa-whatsapp icon" style="font-size: 24px !important"></i>
          </network>
          </a>
        </div>
        </social-sharing>
      </div>
    </div>
  </div>
</template>

<script>
import SocialSharing from 'vue-social-sharing'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    isGeneral: Boolean,
    isTransport: Boolean,
    isFreight: Boolean,
    isOffer: Boolean
  },
  components: {
    SocialSharing
  }
}
</script>

<style scoped>
.social{
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: auto;
}
.content-2{
  padding-top: 10vh; padding-bottom: 12vh;
  background: linear-gradient(-308deg, #326394 -50%, #18283a 70%);
  color: white;
  display: flex; flex-direction: column; justify-content: center;
}
.content-3{
  padding-top: 10vh; padding-bottom: 12vh;
  background: linear-gradient(-308deg, rgba(48, 230, 154, 0.6) -50%, rgba(21, 88, 59, 0.6) 70%);
  color: white;
  display: flex; flex-direction: column; justify-content: center;
}
.content-2-general{
  padding-top: 10vh;
  padding-bottom: 12vh;
  background: linear-gradient(-308deg, #878484 -50%, #111111 70%);
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
h1{
  font-size: 250%;
  margin-top:0;
}
h3{
  font-size:140%;
  line-height: 1.2;
}
.title-main{
  color: #ffa929;
  padding-left: 2%; padding-right: 2%;
  margin-bottom: 1%; margin-top: 0;
}
.title-main-general{
  color: white;
  padding-left: 2%; padding-right: 2%;
  margin-bottom: 1%; margin-top: 0;
}
#sub-title{
  font-size: 94%;
  padding-left: 3%; padding-right: 3%;
}
@media only screen and (max-width: 640px) {
  #content-2{
    height: 102vh;
    font-size: 90%;
  }
}
</style>
